<template>
	<div class="pui-form">
		<mcompatibilidad-modals :modelName="modelName"></mcompatibilidad-modals>

		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<pui-field-set class="ml-4 mr-4 mb-4" :title="getTitleCompatibilidad">
				<v-row class="pui-form-layout">
					<v-col cols="12">
						<v-row dense>
							<!-- ID -->
							<v-col cols="1">
								<pui-text-field
									:id="`id-mcompatibilidad`"
									v-model="model.id"
									:label="$t('mcompatibilidad.id')"
									required
									toplabel
									:disabled="!isCreatingElement"
									maxlength="1"
								></pui-text-field>
							</v-col>
							<!-- PENDIENTE REVISION -->
							<v-col cols="2" class="mt-6">
								<pui-checkbox
									:label="$t('mcompatibilidad.indpendrevision')"
									v-model="model.indpendrevision"
									true-value="1"
									false-value="0"
									:disabled="formDisabled"
								></pui-checkbox>
							</v-col>
						</v-row>
						<v-row dense>
							<!-- DESCRIPCION -->
							<v-col cols="4">
								<pui-text-field
									:id="`descripcion-mcompatibilidad`"
									v-model="model.descripcion"
									:label="$t('mcompatibilidad.descripcion')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="250"
								></pui-text-field>
							</v-col>
						</v-row>
						<v-row dense>
							<!-- FECBAJA -->
							<v-col cols="3">
								<pui-date-field
									:id="`fecbaja-mcompatibilidad`"
									v-model="model.fecbaja"
									:label="$t('mcompatibilidad.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
			</pui-field-set>
			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mcompatibilidadActions from './McompatibilidadActions';
import mcompatibilidadModals from './McompatibilidadModals.vue';

export default {
	name: 'mcompatibilidad-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mcompatibilidad-modals': mcompatibilidadModals
	},
	data() {
		return {
			modelName: 'mcompatibilidad',
			actions: mcompatibilidadActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleCompatibilidad() {
			return this.$t('form.mcompatibilidad');
		}
	},
	created() {}
};
</script>
